import { useState } from 'react'
import Layout from 'shared/layouts/containers/Main'
import useInit from './hooks/useInit'
import { tableColumnWidths } from 'consts'
import getRows from './utils/getRows'
import {
  SearchState,
  IntegratedFiltering,
  SortingState,
  IntegratedSorting,
  DataTypeProvider,
} from '@devexpress/dx-react-grid'
import {
  Grid,
  SearchPanel,
  Table,
  TableColumnResizing,
  TableHeaderRow,
  Toolbar,
} from '@devexpress/dx-react-grid-bootstrap4'
import { TableColumnWidthInfo } from '@devexpress/dx-react-grid/dist/dx-react-grid'
import getBrandContent from 'utils/getBrandContent'
import { formatDateTime } from 'utils/dateUtils'
import Footer from 'shared/components/Footer'
import SearchPanelInput from 'shared/components/SearchPanelInput'

const DateFormatter = ({ value }: { value: string }) => (
  <span>{value ? formatDateTime(new Date(Date.parse(value))) : ''}</span>
)

const TextFormatter = ({ value }: { value: string }) => (
  <span style={{ whiteSpace: 'normal', wordBreak: 'break-word' }}>{value}</span>
)

const AuditLog: React.FunctionComponent = () => {
  const [showOverlay, setShowOverlay] = useState<boolean>(true)
  const [rows, setRows] = useState<any>([])

  const columns: { name: string; title: string }[] = [
    { name: 'id', title: 'ID' },
    { name: 'text', title: 'Text' },
    { name: 'model_id', title: 'Model ID' },
    { name: 'user_email', title: 'User' },
    { name: 'created_at', title: 'Created At' },
  ]

  const columnWidths: TableColumnWidthInfo[] = [
    { columnName: 'id', width: tableColumnWidths.id },
    { columnName: 'text', width: '50%' },
    { columnName: 'model_id', width: tableColumnWidths.id },
    { columnName: 'user_email', width: 'auto' },
    { columnName: 'created_at', width: '16rem' },
  ]

  useInit({ getRows, setRows, setShowOverlay })

  const TableComponent = ({ ...restProps }) => (
    <Table.Table {...restProps} className='min-mobile-width-xs' />
  )

  const SearchPanelInputComponent = (props) => {
    return SearchPanelInput({ inputProps: props })
  }

  return (
    <Layout
      footerContent={<Footer />}
      brandContent={getBrandContent()}
      showMinimizedBarButton={true}
      showOverlay={showOverlay}
    >
      <>
        <Grid rows={rows} columns={columns}>
          <DataTypeProvider for={['text']} formatterComponent={TextFormatter} />
          <DataTypeProvider for={['created_at']} formatterComponent={DateFormatter} />
          <SortingState defaultSorting={[{ columnName: 'created_at', direction: 'desc' }]} />
          <IntegratedSorting />
          <SearchState defaultValue='' />
          <IntegratedFiltering />
          <Toolbar />
          <SearchPanel inputComponent={SearchPanelInputComponent} />
          <Table tableComponent={TableComponent} />
          <TableColumnResizing defaultColumnWidths={columnWidths} resizingMode='nextColumn' />
          <TableHeaderRow showSortingControls />
        </Grid>
      </>
    </Layout>
  )
}

export default AuditLog
